import axios from "axios";
import { useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export const imgUrl = (p) => (!p ? null : p.startsWith("http") ? p : `${API}/files/${p}`);

export const formatPrice = (p) =>
  p === null || p === undefined ? "किंमत विचारा" : `₹ ${Number(p).toLocaleString("en-IN")}`;

export function timeAgo(iso) {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "आत्ताच · Just now";
  if (s < 3600) return `${Math.floor(s / 60)} मिनिटांपूर्वी`;
  if (s < 86400) return `${Math.floor(s / 3600)} तासांपूर्वी`;
  if (s < 86400 * 30) return `${Math.floor(s / 86400)} दिवसांपूर्वी`;
  return new Date(iso).toLocaleDateString("en-IN");
}

const CODES = { LOGIN_REQUIRED: "कृपया आधी Login करा", PLAN_REQUIRED: "Membership घ्या - ₹99 पासून", PLAN_EXPIRED: "प्लॅन संपला - पुन्हा सुरू करा", SOLD_OUT: "SOLD OUT - ही वस्तू विकली गेली आहे" };

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return CODES[d] || d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace("Value error, ", "")).join(" ");
  return String(d);
}

let metaCache = null;
export function useMeta() {
  const [meta, setMeta] = useState(metaCache);
  useEffect(() => {
    if (metaCache) return;
    http.get("/meta").then((r) => { metaCache = r.data; setMeta(r.data); });
  }, []);
  return meta;
}
